export const DRAWER_WIDTH = 500;
export const TW_DRAWER_WIDTH = `w-[500px]`;

export const SAVE_WORKSPACE_TEMPLATE_DESCRIPTION =
  'Save your current workspace setup as a template. This will auto-apply to your personal workspace on new projects.';
export const UPDATE_WORKSPACE_TEMPLATE_DESCRIPTION =
  'Update your existing template with current workspace setup. This will auto-apply to your personal workspace on new projects.';
